<template>
  <v-tooltip
    v-model="showTooltip"
    :activator="!slots.activator ? 'parent' : undefined"
    :location="location"
    :max-width="maxWidth"
    open-on-click
    class="e-tooltip"
    :z-index="zIndex"
    @update:modelValue="onModelValueUpdate"
  >
    <template v-if="slots.activator" #activator="{ props }">
      <div
        :class="{ 'd-inline-flex': inlineFlex, 'd-inline': inline, 'd-flex': !inlineFlex && !inline }"
        v-bind="props"
      >
        <slot :props="props" name="activator" />
      </div>
    </template>

    <slot />
  </v-tooltip>
</template>

<script setup lang="ts">
import type { VTooltip } from 'vuetify/components';

const props = withDefaults(
  defineProps<{
    location?: VTooltip['location'];
    maxWidth?: string | number;
    timeout?: number;
    zIndex?: number;
    inlineFlex?: boolean;
    inline?: boolean;
  }>(),
  {
    location: 'bottom',
    zIndex: 3000,
  },
);

const slots = defineSlots<{
  default: () => void;
  activator?: (props: { props: Record<string, unknown> }) => void;
}>();

const showTooltip = defineModel<boolean>();

let timeoutId = 0;

const onModelValueUpdate = (value: boolean) => {
  if (value && props.timeout) {
    timeoutId = window.setTimeout(() => {
      clearTimeout(timeoutId);
      showTooltip.value = false;
    }, 2000);
  }
};
</script>

<style scoped lang="scss">
.e-tooltip {
  :deep(.v-overlay__content) {
    padding: 16px;

    color: $text-primary-color;

    background-color: $white-color;
    border-radius: $border-radius-l;
    box-shadow: $box-shadow-s;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;

      width: 10px;
      height: 10px;

      background-color: $white-color;

      transform: scaleX(0.8) translate(-50%, -50%) rotate(45deg);
    }

    &[style*='--v-overlay-anchor-origin: right center'] {
      &:before {
        top: 50%;
        left: 0;

        transform: scaleX(0.8) translate(-50%, -50%) rotate(-45deg);
      }
    }

    &[style*='--v-overlay-anchor-origin: top center'] {
      &:before {
        top: 100%;
        left: 50%;

        transform: scaleX(0.8) translate(-50%, -50%) rotate(-45deg);
      }
    }

    &[style*='--v-overlay-anchor-origin: left center'] {
      &:before {
        top: 50%;
        left: 100%;

        transform: scaleX(0.8) translate(-50%, -50%) rotate(-45deg);
      }
    }
  }
}
</style>
